export const DiscountGraphHeader = [
  { id: 1, title: 'No.', flex: 0.7 },
  { id: 2, title: '등록일자', flex: 1.8 },
  { id: 3, title: '국적', flex: 1.2 },
  { id: 4, title: '고객 성함', flex: 3.5 },
  { id: 5, title: '성별', flex: 0.5 },
  { id: 6, title: '시술금액', flex: 3 },
  { id: 7, title: '할인금액', flex: 2 },
  { id: 8, title: '최종 결제 금액', flex: 3 },
  { id: 9, title: '취소', flex: 1 },
];
export const isNotFiltering = [
  'No.',
  '등록일자',
  '국적',
  '고객 성함',
  '성별',
  '시술금액',
  '할인금액',
  '최종 결제 금액',
  '취소',
];
